<template>
  <div id="app">
    <!-- <img src="../../views/apps/our_company/Img/Prueba.png" /> -->
    <img src="./Img/Valores.jpg" width="1700" height="800" />
  </div>
</template>

<script>
export default {};
</script>

<style lang="css"></style>
